import React from "react"
import {FieldViewSmallProps} from "../../../render/view-small";

export default function FieldPopover_ViewSmall(props: FieldViewSmallProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    const valueClasses = Classes("ui5-txt-less-important-small flex-row-left-center", props.className)

    return (
        <div className={valueClasses} onClick={props.onClick}>
            {value && _.get(props.field.components, 'ValueIcon', false)}
            {props.field.getDisplayValue(value)}
        </div>
    );

}